import {Base} from "@/api/Base"

export class PlanCategoryAdd extends Base {
    path = "planCategory/add"
}